<div class="dialog">
    <div class="dialog-header">
        <h2>{{ 'shared.label.networks' | translate }}</h2>
    </div>
    <div class="dialog-body">
        <div class="selector-list">
            <div class="selector-list-item" *ngFor="let network of store.networks">
                <div class="selector-list-image">
                    <img [src]="network.logo | imageFromApi" alt="Network logo">
                </div>
                <div class="selector-list-name">
                    {{ network.name }}
                </div>
            </div>
        </div>

        <div class="buttons">
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>

